import BaseModal from "./modal";
export default BaseModal;
